import React, { useEffect } from "react";

const TripDetailsSection = ({
  register,
  watch,
  setValue,
  tripCreated,
  setTripCreated,
  customers,
  clients,
  branches,
  onBranchChange,
  tripTypes,
  isEditMode,
  role,
  errors,
  isInitializingRef
}) => {

  const branch = watch("branch_id");
  const customer = watch("customer_id");
  const client = watch("client_id");
  const type = watch("type");

  const showCustomer = isEditMode || branch > 0;
  const showClient = isEditMode || (branch > 0 && customer > 0);
  const showType = isEditMode || (branch > 0 && customer > 0 && client > 0);
  const showCreateButton = !isEditMode && branch > 0 && customer > 0 && client > 0 && type && !tripCreated;
  const selectedCustomer = customers.find(c => c.id === Number(customer));
  // const filteredClients = clients.filter(cl => selectedCustomer?.clients?.includes(cl.id));

  const filteredClients = React.useMemo(() => {
    if (!selectedCustomer || !clients.length) return [];
    const list = clients.filter(cl =>
      selectedCustomer.clients?.includes(cl.id)
    );

    if (client && !list.some(c => c.id === client)) {
      const existing = clients.find(c => c.id === client);
      if (existing) list.unshift(existing);
    }

    return list;
  }, [clients, selectedCustomer, client]);

  useEffect(() => {
    if (isEditMode) return;
    if (isInitializingRef.current) return;
    if (!branch) return;

    setValue("customer_id", 0);
    setValue("client_id", 0);
    setValue("type", "");
    setTripCreated(false);
    onBranchChange();
  }, [branch]);

  const onCreateTrip = () => {
    setTripCreated(true);
  };

  return (
    <section>
      {/* <h3 className="text-sm font-semibold mb-2">Trip Details</h3> */}

      <div className="grid md:grid-cols-6 gap-4">

        {/* Branch */}
        {role === "admin" && (
          <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Branch</label>
            <select
              {...register("branch_id", { valueAsNumber: true })}
              className="
              border rounded p-2 text-sm w-full uppercase
              disabled:bg-gray-100
              disabled:text-gray-400
              disabled:border-gray-300
              disabled:cursor-not-allowed
              "
              disabled={isEditMode}
            >
              <option value={0}>Select Branch</option>
              {branches.map(b => (
                <option key={b.id} value={b.id}>{b.name}</option>
              ))}
            </select>
            {errors.branch && (
            <p className="text-red-500 text-sm mt-1">{errors.branch[0]}</p>
            )}
          </div>
        )}

        {/* Customer (only after branch) */}
        {showCustomer && (
          <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Customer</label>
            <select
              {...register("customer_id", { valueAsNumber: true })}
              className="
              border rounded p-2 text-sm w-full uppercase
              disabled:bg-gray-100
              disabled:text-gray-400
              disabled:border-gray-300
              disabled:cursor-not-allowed
              "
              // disabled={isEditMode}
            >
              <option value={0}>Select Customer</option>
              {customers.map(c => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </select>
            {errors.customer && (
              <p className="text-red-500 text-sm mt-1">{errors.customer[0]}</p>
            )}
          </div>
        )}

        {/* Client (only after customer) */}
        {showClient && (
          <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Client</label>
            <select
              {...register("client_id", { valueAsNumber: true })}
              className="
              border rounded p-2 text-sm w-full uppercase
              disabled:bg-gray-100
              disabled:text-gray-400
              disabled:border-gray-300
              disabled:cursor-not-allowed
              "
              // disabled={isEditMode}
            >
              <option value={0}>Select Client</option>
              {filteredClients.map(c => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </select>
            {errors.client && (
              <p className="text-red-500 text-sm mt-1">{errors.client[0]}</p>
            )}
          </div>
        )}

        {/* Trip Type (only after customer) */}
        {showType > 0 && (
          <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Type</label>
            <select
              {...register("type")}
              className="
              border rounded p-2 text-sm w-full uppercase
              disabled:bg-gray-100
              disabled:text-gray-400
              disabled:border-gray-300
              disabled:cursor-not-allowed
              "
              // disabled={isEditMode}
            >
              <option value="">Select Type</option>
              {tripTypes.map(tt => (
                <option key={tt.id} value={tt.id}>{tt.value}</option>
              ))}
            </select>
            {errors.type && (
              <p className="text-red-500 text-sm mt-1">{errors.type[0]}</p>
            )}
          </div>
        )}

        {/* Other Type */}
        {watch("type") === "others" && (
          <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Specify Type</label>
            <input
              {...register("type_other")}
              className="border rounded p-2 text-sm w-full uppercase"
            />
          </div>
        )}
        {/* Create Button (only after type) */}
        {showCreateButton && (
          <div className="flex flex-col">
            <button
              type="button"
              onClick={onCreateTrip}
              className="px-4 py-2  bg-blue-600 text-white rounded mt-5"
            >
              Proceed
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default TripDetailsSection;
